import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["name", "children", "formattedMetaTitle", "image"];
import React, { useContext } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { useSingleImageUrl } from '@blaze-cms/image-cdn-react';
import { MainContext } from '../../context';
import renderMetaTags from './helpers/render-meta-tags';
import { SOCIAL_META } from './constants';
const Header = _ref => {
  let {
      name,
      children,
      formattedMetaTitle,
      image
    } = _ref,
    metaData = _objectWithoutProperties(_ref, _excluded);
  const {
    fullUrl
  } = useContext(MainContext);
  const {
    url
  } = image || {};
  const imageUrl = useSingleImageUrl({
    src: url,
    sizeKey: SOCIAL_META
  });
  return /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("title", null, formattedMetaTitle || name), /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1"
  }), renderMetaTags(fullUrl, imageUrl, metaData, name), children);
};
Header.propTypes = {
  name: PropTypes.string,
  image: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  formattedMetaTitle: PropTypes.string
};
Header.defaultProps = {
  name: null,
  children: null,
  formattedMetaTitle: '',
  image: null
};
export default Header;
//# sourceMappingURL=Header.js.map